const themeStyles = colors => {
  return {
    triggerButton: (isMobile) => ({
      marginLeft: isMobile ? '' : '2rem',
      display: isMobile ? 'block' : '',
      backgroundColor: 'transparent',
      color: colors.primary,
      cursor: 'pointer',
      width: 'fit-content'
    }),
    noDataContainer: {
      padding: 30,
      color: colors.secondaryGray,
      backgroundColor: colors.lighterSmoke
    },
    popupModal: (isMobile, isDarkMode, position) => ({
      minHeight: isMobile ? '4rem' : '4rem',
      minWidth: isMobile ? '16rem' : '20rem',
      maxWidth: isMobile ? '20rem' : '30rem',
      backgroundColor: colors.lighterSmoke,
      border: 'none',
      zIndex: '100',
      boxShadow: isDarkMode
        ? position.includes('top') ? '0px -1px 10px rgba(255, 255, 255, 0.3)' : '0px 1px 10px rgba(255, 255, 255, 0.3)'
        : ''
    }),
    popupContent: (isMobile) => ({
      maxHeight: isMobile ? '24rem' : '30rem',
      overflowY: 'auto'
    }),
    title: (hasBody) => ({
      fontSize: 16,
      color: hasBody ? colors.primary : colors.approxBlack,
      textDecoration: hasBody ? 'underline' : 'none'
    }),
    blurbContainer: {
      color: colors.approxBlack
    },
    errorContainer: {
      padding: 30,
      color: colors.secondaryGray,
      backgroundColor: colors.lighterSmoke,
      marginTop: '1rem'
    },
    errorText: {
      margin: '0 20px',
      textAlign: 'center'
    }
  }
}

export default themeStyles
